<div class="content-container mt-2">
  <div
    class="d-flex flex-column align-items-center"
    [class.container]="!isMultiPlanTok"
    [class.container-fluid]="isMultiPlanTok"
  >
    <div class="text-center title">Thank you for successfully verifying your pet and personal details. {{ petName }}'s transfer is almost complete.</div>

    <ng-container *ngIf="isMultiPlanTok; else singlePlanFlow">
      <p class="text-center fw-semibold mb-3">Choose the membership that's right for you to complete {{ petName }}'s transfer:</p>

      <div class="d-flex flex-column flex-lg-row plan-card-container">
        <div class="plan-col plan-col--plan1 order-2 order-lg-0" *ngIf="plan1Available">
          <app-price-card
            [viewOnly]="true"
            [showShortDescription]="false"
            [showInfoLine]="false"
            [showFeatures]="true"
            [showButton]="true"
            [buttonLabel]="'Buy now'"
            [hasBuyNow]="false"
            [hidePrices]="true"
            [planId]="plan1StripePlanId"
            [userCurrentProductType]="userCurrentProductType"
            [highlighted]="false"
            imageUri="/assets/images/pricingTable/identibasePlus.svg"
            planTitle="{{ plan1Name }}"
            [planLongSubtitle]="plan1Title"
            [hidePlusFromSubtitle]="true"
            yearlyPrice="{{ plan1YearlyPrice }}"
            [features]="plan1Benefits"
            [hideIcon]="true"
            (onSelect)="buyTok($event)"
          ></app-price-card>
        </div>

        <div class="plan-col plan-col--plan2">
          <app-main-plan-card
            [content]="mainCardContent"
            [petName]="petName"
            [hideIcon]="true"
            [useExternalBuyAction]="true"
            [userCurrentProductType]="userCurrentProductType"
            (buyClicked)="buyTok(plan2StripePlanId)"
          ></app-main-plan-card>
        </div>
      </div>

      <p class="mt-3"><a href="/terms-and-conditions" target="_blank"><u class="text-dark">Terms and conditions</u></a></p>
    </ng-container>

    <!-- Standard TOK: single plan -->
    <ng-template #singlePlanFlow>
      <div class="card-container">

        <div class="hero-container-dev">
          <div
            class="hero"
            [style.background-image]="'url(/assets/images/main-plan-card/dog-with-cat.jpeg)'
            "
            [class]="'image-position-cat'"
          >
          </div>

          <div class="container hero-content-text d-flex flex-column">
            <div class="hero-overlay"></div>
            <img
              class="hero-image"
              src="assets/images/main-plan-card/alert-and-TOK.svg"
              alt="alert-and-id"
            />
            <h1 class="mt-2">Transfer of Keepership</h1>
            <p>
              Your transfer of keepership includes immediate access to our premium membership {{ plan2Name }}, helping give {{ petName }} pet protection from day 1.
            </p>
            <p>Learn more about your benefits below.</p>
          </div>
          <div class="splodge-container">
            <img
              class="image"
              src="assets/images/main-plan-card/orange-splodge.png"
              alt="orange-splodge"
            />
            <p class="text">The best start in life with pet protection.</p>
          </div>
        </div>

        <div class="content-container">
          <div class="included-list">
        <ul class="image-text-list">
          <li *ngFor="let con of mainCardContent" class="list-item">
            <img [src]="con.imgSrc" alt="rand" class="list-image" />
            <p>{{ con.text }}</p>
          </li>
        </ul>
      </div>
        </div>
      </div>
      <div class="d-flex flex-column align-items-center justify-content-center">
        <button class="btn btn-secondary text-white btn-lg mt-5 mb-2" (click)="buyTok()">
          <div class="d-flex justify-content-center align-items-center">
            <img width="28" src="assets/images/identibase/whitepawlarge.png" alt="whitepawlarge" class="me-3" *appFeatureFlag="'isPawnVisibleInButton'"/>
            Complete your transfer
          </div>
        </button>
        <div>
          <span class="h2 fw-bold">{{ plan2YearlyPrice }}</span>
        </div>
        <p><a href="/terms-and-conditions" target="_blank"><u class="text-dark">Terms and conditions</u></a></p>
      </div>
    </ng-template>

  </div>
</div>
